const aaa = [
	{
		path: "medicalservice",
		component: () => import("@/views/chanpin/medicalservice/medicalservice.vue"),
		meta:{title:'医疗服务',keepAlive:true},
	},
	{
		path: "addmedicalservice",
		component: () => import("@/views/chanpin/medicalservice/addmedicalservice.vue"),
		meta:{title:'编辑医疗服务'},
	},
    {
		path: "relationconsum",
		component: () => import("@/views/chanpin/consumables/relationconsum.vue"),
		meta:{title:'关联耗材'},
	}
]
export default aaa;